module.exports = __webpack_public_path__ + "img/empty.1f3e3501.svg";